// One source of truth for per-type chrome copy across the vault collaboration
// surface (hub / edit / review / market picker). Keeping the label map + prose
// detection here prevents the "hardcoded Submission Dossier in N places" drift —
// every screen derives its labels from the document ref's source_type.

export const SOURCE_LABELS: Record<string, string> = {
  dossier: 'Submission Dossier',
  predicate: 'Predicate Analysis',
  reference_listed_drug: 'Reference Listed Drug Report',
  reference_product: 'Reference Product Report',
  strategy: 'Regulatory Strategy',
  clinical_protocol: 'Clinical Protocol',
  clinical_report: 'Clinical Report',
};

// Prose (free-text markdown) types edit as section cards; the rest are field docs.
// Mirrors the backend CollabSpec editor_kind for copy purposes only — the editor
// component itself is still chosen by the authoritative `editor_kind` on the draft.
const PROSE_TYPES = new Set(['clinical_protocol', 'clinical_report']);

/** The leading `source_type` segment of a vault ref (e.g. "clinical_protocol:42:US"). */
export function sourceTypeOf(ref: string): string {
  return ref.split(':')[0] ?? '';
}

export function sourceLabel(sourceType: string): string {
  return SOURCE_LABELS[sourceType] ?? 'Document';
}

export function isProseType(sourceType: string): boolean {
  return PROSE_TYPES.has(sourceType);
}
